import type { Shipping as ShippingType } from 'types/capi/shared';

export function getShippingType({ type }: { type?: ShippingType }) {
  switch (type) {
    case 'eu-shipping':
      return 'EU Shipping';
    case 'international-shipping':
      return "Int'l Shipping";
    case 'uk-shipping':
      return 'UK Shipping';
    default:
      return null;
  }
}
